export default __webpack_public_path__ + "static/media/scope.406add77.md";